import QuantityProduct from './QuantityProduct'

class MastPremiumPhotoProduct extends QuantityProduct {}

export default MastPremiumPhotoProduct
